import { render, staticRenderFns } from "./ProofreadingSelectManuscriptPage.vue?vue&type=template&id=2bc956b0"
import script from "./ProofreadingSelectManuscriptPage.vue?vue&type=script&lang=ts"
export * from "./ProofreadingSelectManuscriptPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bc956b0')) {
      api.createRecord('2bc956b0', component.options)
    } else {
      api.reload('2bc956b0', component.options)
    }
    module.hot.accept("./ProofreadingSelectManuscriptPage.vue?vue&type=template&id=2bc956b0", function () {
      api.rerender('2bc956b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/ProofreadingSelectManuscriptPage.vue"
export default component.exports